import {
	EnvironmentalReportModel,
	ExistingFinancingModel,
	GeotechnicalReportModel, MarketingModel, OverviewModel,
	PermitModel,
	ProjectAppraisalModel,
	ScheduleModel,
	SecuredPropertyDetailsModel
} from "./model";

export const EnvironmentalReportSerializer = () => {
	const environmentalReportModel = EnvironmentalReportModel();

	const create = async (body) => await environmentalReportModel.create(body);

	return Object.freeze({
		create,
	});
};

export const ExistingFinancingSerializer = () => {
	const existingFinancingModel = ExistingFinancingModel();

	const create = async (body) => {
		return await existingFinancingModel.create(body);
	};

	return Object.freeze({
		create,
	});
};

export const GeotechnicalReportSerializer = () => {
	const geotechnicalReportModel = GeotechnicalReportModel();

	const create = async (body) => await geotechnicalReportModel.create(body);

	return Object.freeze({
		create,
	});
};

export const OverviewSerializer = () => {
	const overviewModel = OverviewModel();

	const create = async (body) => await overviewModel.create(body);

	return Object.freeze({
		create,
	});
};

export const PermitSerializer = () => {
	const permitModel = PermitModel();

	const create = async (body) => await permitModel.create(body);

	return Object.freeze({
		create,
	});
};

export const ScheduleSerializer = () => {
	const scheduleModel = ScheduleModel();

	const create = async (body) => await scheduleModel.create(body);

	return Object.freeze({
		create,
	});
};


export const MarketingSerializer = () => {
	const marketingModel = MarketingModel();

	const create = async (body) => await marketingModel.create(body);

	return Object.freeze({
		create,
	});
};

export const ProjectAppraisalSerializer = () => {
	const projectAppraisalModel = ProjectAppraisalModel();

	const create = async (body) => await projectAppraisalModel.create(body);

	return Object.freeze({
		create,
	});
};

export const SecuredPropertyDetailsSerializer = () => {
	const securedPropertyDetailsModel = SecuredPropertyDetailsModel();

	const create = async (body) => await securedPropertyDetailsModel.create(body);

	return Object.freeze({
		create,
	});
};
